import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { ADMIN } from '@/lib/adminApi';

const Ctx = createContext({ user: null, loading: true, login: async () => {}, logout: async () => {}, refresh: async () => {} });

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await ADMIN.me();
      setUser(r.user);
    } catch (err) {
      // 401 is expected when the user isn't logged in yet; anything else
      // is worth logging so we don't silently swallow real auth bugs.
      if (err?.response?.status !== 401) {
        // eslint-disable-next-line no-console
        console.error('Admin session refresh failed', err);
      }
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = useCallback(async (email, password) => {
    const r = await ADMIN.login(email, password);
    setUser(r.user);
    return r;
  }, []);

  const logout = useCallback(async () => {
    try {
      await ADMIN.logout();
    } catch (err) {
      // Logout API can fail (network, expired session); we still clear local
      // state so the UI stays consistent. Log for diagnostics.
      // eslint-disable-next-line no-console
      console.warn('Admin logout request failed; clearing client session anyway', err);
    }
    setUser(null);
  }, []);

  return <Ctx.Provider value={{ user, loading, login, logout, refresh }}>{children}</Ctx.Provider>;
}

export const useAdminAuth = () => useContext(Ctx);
